import { render } from "./Self.vue?vue&type=template&id=040e48ec&scoped=true"
import script from "./Self.vue?vue&type=script&lang=js"
export * from "./Self.vue?vue&type=script&lang=js"

import "./Self.vue?vue&type=style&index=0&id=040e48ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040e48ec"]])

export default __exports__